import * as React from "react";
import { IBreadCrumbsProps } from "./BreadCrumbs.types";
import { Icon } from "../Icon/icon";
import { pushTagManagerEvent } from "../../utils/helpers";

/**
 * Renders breadcrumbs for the current page with necessary aria attributes
 */
export class BreadCrumbs extends React.Component<IBreadCrumbsProps> {
  handleBreadcrumbClick = (e) => {
    const linkClicked = e.currentTarget;

    if (linkClicked) {
      e.preventDefault();
      const linkTitle = linkClicked.textContent || "";
      const linkUrl = linkClicked.href || "";
      pushTagManagerEvent(
        "breadcrumb",
        "",
        "",
        "",
        false,
        "",
        "",
        "",
        "",
        linkTitle,
        linkUrl
      );
      window.location.href = linkUrl;
    }
  };

  renderLinks() {
    var links = [];
    var items = this.props.items;
    for (var i = 0; i < items.length; i++) {
      links.push(
        <li key={i}>
          <a
            className="text-breadcrumb"
            href={items[i]["Url"]}
            onClick={this.handleBreadcrumbClick}
          >
            {items[i]["PageName"]}
          </a>
          <Icon iconType="fontawesome/chevron-left" />
        </li>
      );
    }

    return (
      <nav
        className="breadcrumbs"
        aria-label={
          this.props.ariaLabelBreadcrumb
            ? this.props.ariaLabelBreadcrumb
            : "Länkstig"
        }
      >
        <ol className="rtl">
          {links}

          <li>
            <span className="text-breadcrumb active">
              {this.props.currentActivePage}
            </span>
          </li>
        </ol>
      </nav>
    );
  }

  render(): JSX.Element {
    return (
      <div className="main_menu container">
        <div className="row">
          <div className="col">{this.renderLinks()}</div>
        </div>
      </div>
    );
  }
}
